const el = () => document.getElementById("toast");

let hideTimer = null;

export function toast(msg, level = "info") {
  const t = el();
  if (!t) return;
  const bg =
    level === "error" ? "bg-red-600 text-white"
    : level === "ok" ? "bg-emerald-600 text-white"
    : "bg-slate-700 text-slate-100";
  t.className = `fixed bottom-4 right-4 px-4 py-2 rounded-md text-sm font-bold z-50 ${bg}`;
  t.textContent = msg;
  t.classList.remove("hidden");
  if (hideTimer) clearTimeout(hideTimer);
  hideTimer = setTimeout(() => t.classList.add("hidden"), 3500);
}
